<template>
  <div class="yh-page">
    <el-card>
      <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
        <el-col :span="14">
          <span>
            <el-button v-if="showAdd" type="primary" size="small" icon="el-icon-plus" @click="handleDetailCreate">添加收入</el-button>
          </span>
          &nbsp;
          <span>
            <el-button v-if="showAdd" type="primary" size="small" icon="el-icon-plus" @click="handleBatchCreate">批量添加</el-button>
          </span>
          &nbsp;
          <span>
            <!--<el-button v-if="showAdd" type="primary" size="small" icon="el-icon-box" @click="dialogFormVisible = true">寄送信息</el-button>-->
          </span>
          &nbsp;
          <template v-if="is_completed && showConfirm">
          <span>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="handleConfirm">完成收入确认</el-button>
          </span>
          &nbsp;
          </template>
          <span>
            <el-button type="primary" size="small" icon="el-icon-back" @click="goBack">返回</el-button>
          </span>
        </el-col>
      </el-row>

      <table width=100%>
        <tr width=100%>
          <th width=20%>文件名称</th>
          <th width=15%>保险公司</th>
          <th width=15%>所属分公司</th>
          <th width=5%>保费总额</th>
          <th width=5%>手续费总额</th>
          <th width=5%>详单数量</th>
          <th width=5%>开始日期</th>
          <th width=5%>结束日期</th>
          <th width=15%>备注</th>
        </tr>
        <tr>
          <td >{{billingFile.title}}</td>
          <td >{{billingFile.company}}</td>
          <td >{{billingFile.branch_office_name}}</td>
          <td >{{billingFile.total_premium}}</td>
          <td >{{billingFile.total_commission}}</td>
          <td >{{billingFile.total_details}}</td>
          <td >{{billingFile.start_time | parseTime('{y}-{m}-{d}')}}</td>
          <td >{{billingFile.end_time | parseTime('{y}-{m}-{d}')}}</td>
          <td >{{billingFile.remark}}</td>
        </tr>
      </table>
      <hr>

      <table width=100%>
        <tr>
          <th width=10%>收入总额</th>
          <th width=10%>调整后收入总额</th>
          <!-- <th width=10%>操作</th> -->
          <th width=10% >未确认金额</th>
          <th width=37% >已确认金额</th>
          <th></th>
        </tr>
        <tr>
          <td>{{billingFile.total_commission}}</td>
          <td>{{billingFile.adjust_commission}}</td>
          <!-- <td><el-input v-model="billingFile.adjust_commission"></el-input></td> -->
          <!-- <td><el-button type="primary" @click="handleAdjustCommission">调整收入总额</el-button></td> -->
          <td>{{unconfirmed_amount}}</td>
          <td>{{confirmed_amount}}</td>
          <td></td>
        </tr>
      </table>
      <hr>
      <!--
      <table width=100%>
        <tr>
          <th width=10%>寄送日期</th>
          <th width=10%>物流公司</th>
          <th width=10%>物流单号</th>
          <th width=10%>收件人名称</th>
          <th>收件地址</th>
          <th></th>
        </tr>
        <tr>
          <td>{{deliver_date | parseTime('{y}-{m}-{d}')}}</td>
          <td>{{deliver_company}}</td>
          <td>{{deliver_number}}</td>
          <td>{{deliver_receiver}}</td>
          <td>{{deliver_address}}</td>
          <td></td>
        </tr>
      </table>
      <hr>-->

      <!-- 账单文件列表 -->
      <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText"
                fit highlight-current-row class="w-100">
        <!-- id -->
        <el-table-column align="left" label="id" width="70">
          <template slot-scope="scope">
            <span v-if="showView">
              <el-tooltip content="未上传附件" placement="top" v-if="scope.row.is_uploaded===0">
                <i class="el-icon-warning" style="color:red" />
              </el-tooltip>
              {{scope.row.id}}
            </span>
          </template>
        </el-table-column>

        <!-- 收入类型-->
        <el-table-column align="left" label="类型" width="80">
          <template slot-scope="scope">
            <span  v-if="showView"
              >{{ scope.row.income_type | parsereincometype}}</span>
          </template>
        </el-table-column>

        <!-- 业务单位明细-->
        <el-table-column align="left" label="业务单位明细">
          <template slot-scope="scope">
            <span  v-if="showView"
              >{{ scope.row.insurance_company}}</span>
          </template>
        </el-table-column>

        <!-- 税价 -->
        <el-table-column align="left" label="税价" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.vat| parsecurrency}}</span>
          </template>
        </el-table-column>

        <!-- 销售额 -->
        <el-table-column align="left" label="销售额" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.sales| parsecurrency}}</span>
          </template>
        </el-table-column>

        <!-- 税价合计 -->
        <el-table-column align="left" label="税价合计" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.amount| parsecurrency}}</span>
          </template>
        </el-table-column>

        <!-- 开票金额 -->
        <el-table-column align="left" label="开票金额" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.invoiced_amount| parsecurrency}}</span>
          </template>
        </el-table-column>

        <!-- 不开票金额 -->
        <el-table-column align="left" label="不开票金额" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.non_invoiced_amount| parsecurrency}}</span>
          </template>
        </el-table-column>

        <!-- 发票号码 -->
        <el-table-column align="left" label="发票号码" width="120px">
          <template slot-scope="scope">
            <span  v-if="showView"
              >{{ scope.row.invoice_number }}</span>
          </template>
        </el-table-column>

        <!-- 纳税人识别号 -->
        <el-table-column align="left" label="纳税人识别号" width="220px">
          <template slot-scope="scope">
            <span  v-if="showView"
              >{{ scope.row.taxpayer_id }}</span>
          </template>
        </el-table-column>

        <!-- 开票时间 -->
        <el-table-column align="left" label="开票时间" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.invoiced_date| parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </el-table-column>

        <!-- 收款日期 -->
        <el-table-column align="left" label="收款日期" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.received_date | parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.remark}}</span>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column align="left" label="操作" width="150px">
          <template slot-scope="scope">

            <el-tooltip effect="light" placement="top-start" content="编辑">
              <el-button v-if="showEdit" type="text"
                @click="handleUpdate(scope.row.id, showDialogSave)" >
                <i class="el-icon-edit"></i>
              </el-button>
            </el-tooltip>

            <el-tooltip effect="light" placement="top-start" content="删除">
              <el-button v-if="showDelete" type="text"
                @click="handleDelete(scope.row.id)" >
                <i class="el-icon-delete"></i>
              </el-button>
            </el-tooltip>

          </template>
        </el-table-column>

      </el-table>
    </el-card>

    <pagination :size.sync="query.limit" :offset.sync="query.offset" :total="total" ></pagination>
    <receivable-detail-dialog ref="detail"
        :billing_file_id="billing_file_id"
        :adjust_commission="adjust_commission"
        :confirmed_amount="confirmed_amount"
        :unconfirmed_amount="unconfirmed_amount" ></receivable-detail-dialog>
    <receivable-batch-dialog ref="batch"
        :billing_file_id="billing_file_id"></receivable-batch-dialog>

    <el-dialog title="发票寄送信息" :visible.sync="dialogFormVisible">
      <el-form ref="deliverForm" :model="deliver_form" :rules="rules">
        <el-form-item label="寄送日期" label-width="120px" prop="date">
          <el-date-picker
            v-model="deliver_form.date"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="物流公司" label-width="120px" prop="company">
          <el-select v-model="deliver_form.company" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" label-width="120px" prop="number">
          <el-input v-model="deliver_form.number" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="收件人名称" label-width="120px" prop="receiver">
          <el-input v-model="deliver_form.receiver" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="收件地址" label-width="120px" prop="address">
          <el-input v-model="deliver_form.address" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetDeliverForm">取 消</el-button>
        <el-button type="primary" @click="handleDeliverForm">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import { confirmRecordsFieldStatus } from '@/api/billing'
  import { deleteReceivable } from '@/api/billing'
  import { fetchBillingFile } from '@/api/billing'
  import { fetchReceivableList } from '@/api/billing'
  import { updateDeliverInfo } from '@/api/billing'
  // import { adjustCommission } from '@/api/billing'
  import { parseTime } from '@/utils'
  import { EventBus } from "@/utils/event-bus"
  import { formatCurrency } from '@/utils/misc'
  import Pagination from '@/components/Pagination'
  import ReceivableDetailDialog from './receivable-detail-dialog'
  import ReceivableBatchDialog from './receivable-batch-dialog'

  export default {
    name: "receivable-list",
    components: {
      Pagination,
      ReceivableDetailDialog,
      ReceivableBatchDialog
    },

    filters: {
      parsecurrency: function(value){
        return formatCurrency(value, 2)
      },
      parsereincometype: function(value) {
        let result
        switch(parseInt(value)){
          case 0:
            result = "未选择"
            break
          case 1:
            result = "公账"
            break
          case 2:
            result = "私账"
            break
          default:
            result = "未选择"
        }
        return result
      }
    },

    data() {
      return {
        showView: false,
        showAdd: false,
        showEdit: false,
        showDelete: false,
        showConfirm: false,
        showDialogSave: true,
        company: '',
        billing_file_id: 0,
        billing_model: '',
        company_code: '',
        branch_office_code: '',
        searching: false,
        loading: false,
        loadingText: '正在加载数据，请稍等...',
        query: {
          search: '',
          offset: 0,
          limit: 20
        },
        total: 0,
        list: [],
        billingFile:[],
        total_commission: 0.0,
        adjust_commission: 0.0,
        dialogFormVisible: false,
        deliver_date: '',
        deliver_number: '',
        deliver_company: '',
        deliver_receiver: '',
        deliver_address: '',
        deliver_form: {
          date: new Date(),
          company: '顺丰',
          number: null,
          receiver: null,
          address: null
        },
        options:[
          {value: '顺丰'},
          {value: 'EMS'},
          {value: '圆通'},
          {value: '申通'},
          {value: '中通'},
          {value: '其它'}
        ],
        rules: {
          number: [
            { required: true, message: '请输入物流单号', trigger: 'blur' },
          ],
          company: [
            { required: true, message: '请选择物流公司', trigger: 'blur' },
          ],
          date: [
            { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
          ],
        }
      }
    },

    computed:{
      confirmed_amount: function() {
        let result = 0.0
        for (let l of this.list) {
          result = result + parseFloat(l.amount)
        }
        return result.toFixed(4)
      },
      unconfirmed_amount: function() {
        let result = 0.0
        result = this.adjust_commission - this.confirmed_amount
        return result.toFixed(4)
      },
      all_uploaded: function() {
        let result = true
        for (let l of this.list) {
          if (l.is_uploaded === 0) {
            result = false
          }
        }
        return result
      },
      is_completed: function() {
        let result = false
        if (this.billingFile.adjust_commission === parseFloat(this.confirmed_amount)
          && parseFloat(this.unconfirmed_amount) === 0.0
          // && Object.keys(this.billingFile.deliver_info).length !== 0
          && this.all_uploaded){
          result = true
        }
        return result
      }
    },
    methods: {
      getList() {
        this.loading = true
        let p = []
        p.push(fetchBillingFile(this.billing_file_id))
        p.push(fetchReceivableList(this.billing_file_id))
        Promise.all(p)
          .then(res => {
            this.billingFile = res[0]
            this.adjust_commission = this.billingFile.adjust_commission
            this.deliver_date = this.billingFile.deliver_info.date
            this.deliver_number = this.billingFile.deliver_info.number
            this.deliver_company = this.billingFile.deliver_info.company
            this.deliver_receiver = this.billingFile.deliver_info.receiver
            this.deliver_address = this.billingFile.deliver_info.address
            this.list = res[1]
            this.loading = false
            if (this.billingFile.is_invoiced === 1){
              this.showAdd = false
              this.showConfirm = false
              // this.showEdit = false
              this.showDelete = false
              this.showDialogSave = false
            }
          })
          .catch(error => {
            this.loading = false
            this.$error_message(error)
          })
      },
      goBack() {
        this.$router.go(-1)
      },
      handleDetailCreate() {
        this.$refs.detail.handleCreate(this.branch_office_code)
      },
      handleBatchCreate() {
        this.$refs.batch.handleCreate(this.company_code, this.branch_office_code)
      },
      handleConfirm() {
        this.$confirm('确认后将完成收入确认,完成后该对账文件和相应的保单信息将不允许修改以及删除, 是否继续?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          confirmRecordsFieldStatus('confirmed', this.billing_model, this.billing_file_id)
            .then(() => {
              this.$message.success('更新账单信息成功')
              this.$nextTick(() => {
                this.$message({
                  type: 'success',
                  message: '收入确认成功!'
                });
              })
            })
            .catch(error => {
              this.$message.error(error)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消收入确认'
          });
        });
      },
      handleUpdate(id, showDialogSave) {
        this.$refs.detail.handleUpdate(id, this.branch_office_code, showDialogSave)
      },
      handleDelete(id){
        this.$confirm('是否确认删除该笔收入继续?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          deleteReceivable(this.billing_file_id, id)
            .then(() => {
              this.$nextTick(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              setTimeout(() => {
                this.getList()
              }, 1000)
              })
            })
            .catch(error => {
              this.$message.error(error)
            })
        }).catch((e) => {
          console.log(e)
          this.$message({
            type: 'info',
            message: '取消删除'
          });
        });
      },
      resetDeliverForm() {
        this.$refs['deliverForm'].resetFields();
        this.dialogFormVisible = false
      },
      handleDeliverForm() {
        this.$refs['deliverForm'].validate((valid) => {
          if (valid) {
            updateDeliverInfo(this.deliver_form, this.billing_file_id)
            .then(() => {
              this.$nextTick(() => {
                this.$message({
                  type: 'success',
                  message: '提交寄送信息成功!'
                });
              setTimeout(() => {
                this.getList()
              }, 1000)
              })
              this.resetDeliverForm()
              this.dialogFormVisible = false
            })
            .catch(error => {
              this.$message.error(error)
            })
          }
          else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },

    created() {
      // 入参处理
      if (this.$route.query.billing_model === undefined || this.$route.query.billing_file_id === undefined){
        this.$router.push('/404')
      }
      this.billing_file_id = this.$route.query.billing_file_id
      this.billing_model = this.$route.query.billing_model
      this.company_code = this.$route.query.company_code
      this.branch_office_code = this.$route.query.branch_office_code
      console.log(this.$route.query.billing_file_id)
      console.log(this.$route.query.billing_model)
      console.log(this.$route.query.company_code)
      console.log(this.$route.query.branch_office_code)
      // 权限检查
      if (!this.$perm(["billing.list_receivable"])) {
        this.$router.push('/401')
      }
      this.showView = true

      if (this.$perm(["billing.create_receivable"])) {
        this.showAdd = true
      }

      if (this.$perm(["billing.confirm_receivable"])) {
        this.showConfirm = true
      }

      if (this.$perm(["billing.update_receivable"])) {
        this.showEdit = true
      }

      if (this.$perm(["billing.delete_receivable"])) {
        this.showDelete = true
      }

      EventBus.$on('created-receivable', () => {
        setTimeout(() => {
          this.getList()
        }, 1000)
      })

      EventBus.$on('updated-receivable', () => {
        setTimeout(() => {
          this.getList()
        }, 2000)
      })

      this.getList()
    }
  }
</script>
